export default function TrustStatistics() {
  return (
    <section className="bg-[#1A1A1A] py-12 md:py-16 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 text-center">
          <div>
            <div
              className="text-4xl md:text-5xl font-bold mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif', color: '#F2C612' }}
            >
              26+
            </div>
            <p className="text-white text-sm md:text-base">Years in Business</p>
          </div>
          <div>
            <div
              className="text-4xl md:text-5xl font-bold mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif', color: '#F2C612' }}
            >
              10,000+
            </div>
            <p className="text-white text-sm md:text-base">Projects Completed</p>
          </div>
          <div>
            <div
              className="text-4xl md:text-5xl font-bold mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif', color: '#F2C612' }}
            >
              500+
            </div>
            <p className="text-white text-sm md:text-base">Trusted Stockists</p>
          </div>
        </div>
      </div>
    </section>
  );
}